import React, { useState, useEffect } from "react";
// 假设你的 service、model、类型定义等路径和命名如下，若实际不同请自行替换
import { externalBillService } from "../externalBillService";
import { useExternalBillModel } from "../externalBillModel";
import { momentFormat, momentFormats } from '@/utils/utils';
import useGlobalModel from "@/model/globalModel";

interface PropsType {
    approvalPrintVisible: boolean;
    setApprovalPrintVisible: (visible: boolean) => void;

}

export const ApprovalPrintTable = (props: PropsType) => {
    const { approvalPrintVisible, setApprovalPrintVisible } = props;
    const { descRows } = useExternalBillModel();
    const [chunkedData, setChunkedData] = useState<any>([]);
    useEffect(() => {
        if (approvalPrintVisible) {
            const chunkSize = 6;
            let newData: any = []
            for (let i = 0; i < descRows.length; i += chunkSize) {
                newData.push(descRows.slice(i, i + chunkSize));
            }
            setChunkedData(newData);
        }
    }, [approvalPrintVisible]);
    useEffect(() => {
        if (chunkedData.length > 0) {
            print();
        }
    }, [chunkedData]);
    const { CustomerData, shopAndOrg: { shopName, shopId } } = useGlobalModel()
    const print = () => {
        const el: HTMLElement | null = document.getElementById('approvalPrint-container');
        const iframe: HTMLIFrameElement = document.createElement('iframe');
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow?.document;
        if (doc) {
            doc.open();
            // 引入打印样式，若有专属的接车单样式可替换路径
            doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
            doc.write(el?.innerHTML || '');
            doc.close();
        }

        iframe.contentWindow?.addEventListener('afterprint', () => {
            document.body.removeChild(iframe);
            setApprovalPrintVisible(false);
        });

        iframe.contentWindow?.focus();
        iframe.onload = () => {
            iframe.contentWindow?.print();
        };

        if (navigator.userAgent.indexOf("MSIE") > 0) {
            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 100);
        }
    };

    return (
        <div style={{ display: 'none' }}>
            <div id="approvalPrint-container" className="offerPrint-container">
                {chunkedData.map((chunk: any, pageIndex: any) => (
                    <div key={`${pageIndex}`} className="print-page">
                        <div style={{ textAlign: 'center', fontSize: 24, fontFamily: "FangSong", fontWeight: 'normal', margin: "13px 0px" }}>
                            {`${shopName}车辆外修审批单`}
                        </div>
                        <table className="mingxi" style={{ border: "1px solid black" }}>
                            <thead>
                                <tr style={{ lineHeight: 4 }}>
                                    {['外修编号', '报修日期', '车辆所属单位', '车号', '车辆类型', '报修原因', '申请站点', '修理厂家'].map((th, i) => (
                                        <th key={i} style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}>{th}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>

                                {chunk.map((row: any, rowIndex: number) => (

                                    <tr key={rowIndex} style={{ lineHeight: 4 }}>
                                        <td style={{ width: 80, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.code}</td>
                                        <td style={{
                                            width: 80, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-all',
                                            lineHeight: '1.4', height: '24px',
                                        }}>
                                            <div style={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2, overflow: 'hidden'
                                            }}>{momentFormats(row.createTime)}</div>
                                        </td>
                                        <td style={{
                                            width: 100, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-all',
                                            lineHeight: '1.4', height: '24px',
                                        }}>
                                            <div style={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2, overflow: 'hidden'
                                            }}>{row.customerName}</div>
                                        </td>
                                        <td style={{
                                            width: 100, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-all',
                                            lineHeight: '1.4', height: '24px',
                                        }}>
                                            <div style={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2, overflow: 'hidden'
                                            }}>{row.licensePlate}</div>
                                        </td>
                                        <td style={{
                                            width: 70, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-all',
                                            lineHeight: '1.4', height: '24px',
                                        }}>
                                            <div style={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2, overflow: 'hidden'
                                            }}>{row.vehicleTypeName}</div>
                                        </td>
                                        <td style={{
                                            width: 120, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal',
                                            wordBreak: 'break-all',
                                            lineHeight: '1.4', height: '24px',
                                        }}>
                                            <div style={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2, overflow: 'hidden'
                                            }}>{row.faultDesc}</div>
                                        </td>
                                        <td style={{
                                            width: 60, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal',
                                            wordBreak: 'break-all',
                                            lineHeight: '1.4', height: '24px',
                                        }}>
                                            <div style={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2, overflow: 'hidden'
                                            }}>{row.shopName}</div>
                                        </td>
                                        <td style={{
                                            width: 140, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-all',
                                            lineHeight: '1.4', height: '24px',
                                        }}>
                                            <div style={{
                                                display: '-webkit-box',
                                                WebkitBoxOrient: 'vertical',
                                                WebkitLineClamp: 2,
                                                overflow: 'hidden',
                                                lineHeight: 1.8
                                            }}>
                                                {['恒源', '神杰', '卓一', '云豪', '中联', '神州', '鼎盛'].map(name => (
                                                    <span key={name} style={{ marginRight: '10px', whiteSpace: 'nowrap' }}>
                                                        {name}
                                                        {row.supplierName?.includes(name) ? '☑ ' : '□'}
                                                    </span>
                                                ))}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {/* 补充当前页的空白行 */}
                                {Array.from({
                                    length: Math.max(6 - chunk.length, 0)
                                }).map((_, i) => (
                                    <tr key={`empty-${i}`} style={{ lineHeight: 4 }}>
                                        {Array(8).fill(null).map((_, i) => (
                                            <td key={i} style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>&nbsp;</td>
                                        ))}
                                    </tr>
                                ))}

                                <tr style={{ lineHeight: 4 }}>
                                    <td colSpan={2} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>经办人</td>
                                    <td colSpan={6} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', position: 'relative', }}>
                                        <div style={{ position: 'absolute', bottom: '5px', left: '5px', fontSize: 14 }}>
                                            签名：
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: 14 }}>
                                            年&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;日
                                        </div>
                                    </td>
                                </tr>
                                <tr style={{ lineHeight: 4 }}>
                                    <td colSpan={2} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>生产部</td>
                                    <td colSpan={6} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', position: 'relative', }}>
                                        <div style={{ position: 'absolute', bottom: '5px', left: '5px', fontSize: 14 }}>
                                            审批意见：
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '5px', left: '40%', fontSize: 14 }}>
                                            签名：
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: 14 }}>
                                            年&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;日
                                        </div>
                                    </td>
                                </tr>
                                <tr style={{ lineHeight: 4 }}>
                                    <td colSpan={2} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>主管领导审批</td>
                                    <td colSpan={6} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', position: 'relative', }}>
                                        <div style={{ position: 'absolute', bottom: '5px', left: '5px', fontSize: 14 }}>
                                            审批意见：
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '5px', left: '40%', fontSize: 14 }}>
                                            签名：
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: 14 }}>
                                            年&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;日
                                        </div>
                                    </td>
                                </tr>
                                <tr style={{ lineHeight: 4 }}>
                                    <td colSpan={2} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>总经理审批</td>
                                    <td colSpan={6} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', position: 'relative', }}>
                                        <div style={{ position: 'absolute', bottom: '5px', left: '5px', fontSize: 14 }}>
                                            审批意见：
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '5px', left: '40%', fontSize: 14 }}>
                                            签名：
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '5px', right: '5px', fontSize: 14 }}>
                                            年&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;日
                                        </div>
                                    </td>
                                </tr>
                                <tr style={{ lineHeight: 2 }}>
                                    <td colSpan={2} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', textAlign: 'center' }}>备注</td>
                                    <td colSpan={6} style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', border: '1px solid black', position: 'relative', }}>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                ))
                }
            </div>
        </div>
    );
};